import { Link } from 'react-router-dom'
import type { Article } from '../data/articles'
import { getAuthor } from '../data/authors'
import VoteWidget from './VoteWidget'

function Byline({ authorSlug }: { authorSlug: string }) {
  const author = getAuthor(authorSlug)
  return (
    <Link className="by" to={`/authors/${author.slug}`}>
      {author.name}
    </Link>
  )
}

function FeaturedCard({ article }: { article: Article }) {
  return (
    <article className="card feat">
      <div className="thumb" aria-hidden="true">
        <div className="grtick"></div>
        <div className="cap">
          <span className="tag">{article.tag}</span>
        </div>
        <div className="bignum">
          <span className="bn-lab">Claimed shelf life</span>
          <span className="bn-fig">
            25<span style={{ fontSize: 24 }}>YR</span>
          </span>
        </div>
      </div>
      <div className="body">
        <div className="meta">
          <span className="stamp">Dispatch</span>
          <span className="stamp tnum">{article.date}</span>
        </div>
        <h3>
          <Link to={`/articles/${article.slug}`}>{article.title}</Link>
        </h3>
        <p className="dek">{article.dek}</p>
        {article.vote && <VoteWidget poll={article.vote} />}
        <div className="foot">
          <Byline authorSlug={article.authorSlug} />
          <Link className="read" to={`/articles/${article.slug}`}>
            Read <span aria-hidden="true">&rarr;</span>
          </Link>
        </div>
      </div>
    </article>
  )
}

function Card({ article }: { article: Article }) {
  return (
    <article className="card">
      <div className="meta">
        <span className="tag">{article.tag}</span>
        <span className="stamp tnum">{article.date}</span>
      </div>
      <h3>
        <Link to={`/articles/${article.slug}`}>{article.title}</Link>
      </h3>
      <p className="dek">{article.dek}</p>
      {article.vote && <VoteWidget poll={article.vote} />}
      <div className="foot">
        <Byline authorSlug={article.authorSlug} />
        <Link className="read" to={`/articles/${article.slug}`}>
          Read <span aria-hidden="true">&rarr;</span>
        </Link>
      </div>
    </article>
  )
}

export default function ArticleGrid({ featured, rest }: { featured: Article; rest: Article[] }) {
  return (
    <section className="wrap sec" id="articles">
      <div className="sec-head">
        <div>
          <div className="idx">
            FIELD DISPATCHES &middot; <b>LIVE FEED</b>
          </div>
          <h2>Latest From The Field</h2>
        </div>
        <Link className="link-more" to="/articles">
          Full Archive &rarr;
        </Link>
      </div>
      <div className="art-grid">
        <FeaturedCard article={featured} />
        {rest.map((a) => (
          <Card key={a.slug} article={a} />
        ))}
      </div>
    </section>
  )
}
